const stripNonNumber = (val) => {
    return val
      .split("")
      .map((item) => {
        return !isNaN(item) || item === "." ? item : "";
      })
      .join("")
      .replaceAll(" ", "");
}


export default stripNonNumber